<template>
        <!-- ApexChart Realtime -->
        <div>
            <apexchart type="line" height="200" ref="chart" :options="chartRealtimeOptions" :series="seriesRealtime"></apexchart>
        </div>
</template>

<script>
/* Import required Chart library */
import VueApexCharts from "vue-apexcharts";
var realtimeLRT = [];

function resetRealtimeData() {
    // Alternatively, you can also reset the data at certain intervals to prevent creating a huge series 
    realtimeLRT = realtimeLRT.slice(realtimeLRT.length - 10, realtimeLRT.length);
}

export default {
    name: 'DeviceData',
    components: {
        apexchart: VueApexCharts,
    },
    data: function () {
        return {
            /* Realtime Chart Setup */
            seriesRealtime: [{
                name: 'Liquid Temp',
                data: realtimeLRT.slice()
            }],
            chartRealtimeOptions: {
                chart: {
                    id: 'realtime',
                    height: 350,
                    type: 'line',
                    animations: {
                        enabled: true,
                        easing: 'linear',
                        dynamicAnimation: {
                            speed: 500
                        }
                    },
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    }
                },
                foreCastDataPoints: {count: 5, fillOpacity: 0.5, strokeWidth: 2, dashArray: 10,},
                tooltip: {
                    theme: 'dark'
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    // text: 'Realtime Device Temperature ℃',
                    align: 'center'
                },
                markers: {
                    // shape: 'circle',
                    // size: 2
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false
                    }
                },
                yaxis: {
                    // title: {
                    //     text: "℃", rotate: 0
                    // }
                },
                legend: {
                    show: false
                },
            },
            /* End Realtime Chart Setup */

            CurrentTemp: null,
            FlowActual: null,

            deviceDataLoaded: false,

            realtimeIntervalID: null,
            resetDataIntervalID: null,
        };
    },
    props: ['item'],
    mounted: function () {
        var me = this;
        this.seriesRealtime = [];
        realtimeLRT = [];

        this.refreshData();
        //this.refreshTrendData();

        /* Priodically refresh data (currently set to every 5 seconds) */
        this.realtimeIntervalID = window.setInterval(function () {
            /* Load data and attach to charts */
            me.refreshData();
            me.updateCharts();

        }, 5000)

        // every 60 minutes, we reset the data to prevent memory leaks
        this.resetDataIntervalID = window.setInterval(function () {
            resetRealtimeData();

            me.refreshData();
            me.updateCharts();

        }, 600000*60)
    },
    beforeDestroy() {
        clearInterval(this.realtimeIntervalID);
        clearInterval(this.resetDataIntervalID);
    },
    methods: {
        updateCharts() {
            this.seriesRealtime = [{ name: 'Liquid Temp', data: realtimeLRT }];
        },
        async refreshData() {

            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices/" + this.item.id + "/data?mode=stream"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i]
                    
                    if (element[0].TagID == "analogs_lc_lrt_scaled") {
                        realtimeLRT.push([new Date(element[0].ConvertedLocalDateTime).toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }), element[0].TagValue.toFixed(1)]);
                        this.CurrentTemp = element[0].TagValue; this.CurrentTemp = element[0].TagValue.toFixed(1);
                    }
                    if (element[0].TagID == "pids_lc_flow_pid_pv") this.FlowActual = element[0].TagValue.toFixed(1);
                }

                this.deviceDataLoaded = true;

            } catch (error) {
                console.log(error);
            }
        },
    }
};

</script>

<style>
#main-container {
    display: block;
}

#charts-container {
    display: block;
}


#chart-line {
    position: relative;
    margin-top: -40px;
}

#chart-realtime {
    max-width: 75%;
    min-width: 75%;
    min-height: 400px;
    margin: 35px auto;
    padding-left: 20px;
    float: left;
}

</style>